import Vue from 'vue'

/**
 * @author jorge nuñez lópez <>
 *
 * Adjustment for a specific supply
 * @param warehouseId Id of specific warehouse
 * @param currenteMovementId Id of current supply movement
 * @return {object}
 */

const transformer = (data) => ({
  responsible_user: data.responsible,
  current_quantity: data.currentQuantity,
  unit_price: data.unitPrice,
})

export default (warehouseId, adjustment, currentMovementId) => {
  const payload = transformer(adjustment)
  return Vue.$http.put(`purchase/warehouse/${warehouseId}/supply-adjustments/${currentMovementId}/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/supplyAdjustment.js